import { component as defineComponent } from 'flightjs';

export default defineComponent(function () {
    this.attributes({
        'title': '[data-header-title]',
        'subtitle': '[data-header-subtitle]',
        'categoryHeadingMap': null,
    });

    this.after('initialize', function () {
        this.on(document, 'uiBrowseFiltersUpdated', this.toggleDisplay);
    });

    this.toggleDisplay = function (e, data) {
        if (data.category && this.attr.categoryHeadingMap) {
            const heading = this.attr.categoryHeadingMap[data.category];

            if (heading) {
                this.select('title').text(heading);
                this.select('subtitle').hide();
            }
        }
    };
});



// WEBPACK FOOTER //
// ./src/web/js/browse/ui/header.js